export enum IotDevicesModalTypes {
    SensorBatchModal,
    SensorModal
}

